import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import addBook from "../redux/middlewares/thunk/books/createBooksMiddleware";
import editBook from "../redux/middlewares/thunk/books/updateBookMiddleware";
function BookForm() {
  const dispatch = useDispatch();
  const updateInfo = useSelector((state) => state.form);

  const [formData, setFormData] = useState({
    name: null,
    author: null,
    thumbnail: null,
    price: null,
    rating: null,
    featured: false,
  });

  useEffect(() => {
    setFormData({ ...updateInfo.data });
  }, [updateInfo.data]);

  function handleForm(event) {
    if (event.type === "submit") {
      event.preventDefault();
      if (updateInfo.shouldUpdate) {
        dispatch(editBook(formData));
      } else {
        dispatch(addBook(formData));
      }
      //Reset Form
      event.target.reset();
      setFormData({
        name: null,
        author: null,
        thumbnail: null,
        price: null,
        rating: null,
        featured: false,
      });
    } else {
      if (event.target.name === "featured") {
        setFormData({ ...formData, featured: !formData.featured });
      } else {
        setFormData({ ...formData, [event.target.name]: event.target.value });
      }
    }
  }
  return (
    <div>
      <div className="p-4 overflow-hidden bg-white shadow-cardShadow rounded-md">
        <h4 className="mb-8 text-xl font-bold text-center">Add New Book</h4>
        <form className="book-form" onSubmit={handleForm}>
          <div className="space-y-2">
            <label htmlFor="name">Book Name</label>
            <input
              value={formData.name}
              required
              className="text-input"
              type="text"
              id="input-Bookname"
              name="name"
              onChange={handleForm}
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="category">Author</label>
            <input
              value={formData.author}
              required
              className="text-input"
              type="text"
              id="input-Bookauthor"
              name="author"
              onChange={handleForm}
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="image">Image Url</label>
            <input
              value={formData.thumbnail}
              required
              className="text-input"
              type="text"
              id="input-Bookthumbnail"
              name="thumbnail"
              onChange={handleForm}
            />
          </div>

          <div className="grid grid-cols-2 gap-8 pb-4">
            <div className="space-y-2">
              <label htmlFor="price">Price</label>
              <input
                value={formData.price}
                required
                className="text-input"
                type="number"
                id="input-Bookprice"
                name="price"
                onChange={handleForm}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="quantity">Rating</label>
              <input
                value={formData.rating}
                required
                className="text-input"
                type="number"
                id="input-Bookrating"
                name="rating"
                min="1"
                max="5"
                onChange={handleForm}
              />
            </div>
          </div>

          <div className="flex items-center">
            <input
              checked={formData.featured}
              id="input-Bookfeatured"
              type="checkbox"
              name="featured"
              className="w-4 h-4"
              onChange={handleForm}
            />
            <label htmlFor="featured" className="ml-2 text-sm">
              This is a featured book
            </label>
          </div>

          <button type="submit" className="submit" id="submit">
            {updateInfo.shouldUpdate ? "Update Book" : "Add Book"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default BookForm;
